import { connect, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import "./udpateUserModal.css"
import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { allPermissionsListWithLabel, userPermissions, categorziedPermissions } from './PermissionsUpdateUserModal';
import OptionalDropdownSelect from './OptionalDropdownSelect';
import { getCompanyGroupByUser ,getUserCompanyGroup} from '../actions/Companies';
import SpinnerCircles from './Spinner/SpinerCircles';
import {
  Button,
  Col,
  Container,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import {
  changeFieldUpdateUser,
  resetPasswordByOld,
  getUserPermissions,
  userResetPassword,
  getUserAccountLock,
  getOobmDeviceEnabled,
  assignUsersOobm,
  getUserOobm
} from '../actions/Users';
import UpdateUserForm from './UpdateUserForm';
import AddSecurityCodeModal from './AddSecurityCodeModal';
import CustomModal from './CustomModal';

import { useUnifiedFetch, useUpdateUserModal } from '../hooks';
import ResetPassword from './ResetPassword';
import utils from '../lib/utils';
import { Checkbox, ConfigProvider, Flex, Popconfirm } from 'antd';
import { RESTRICTED_PERMISSION_GROUPS } from '../utils/constants';
import edit from '../Res/Icon/edit.png';
import del from '../Res/Icon/delete.png';

const adminCustomerItems = [
  { label: 'Admin', value: 'admin' },
  { label: 'User', value: 'user' },
];
const adminItems = [
  // { label: 'Agent', value: 'agent' },
  { label: 'Admin', value: 'admin' },
  // { label: 'Enterprise Admin', value: 'enterpriseAdmin' },
  { label: 'User', value: 'user' },
  // { label: 'Manufacturer', value: 'manufacturer' },
  // { label: 'Support Engineer', value: 'supportEngineer' },
  // { label: 'CompanyGroupManager', value: 'companyGroupManager' },
];

const superAdminItems = [
  { label: 'User', value: 'user' },
  { label: 'Agent', value: 'agent' },
  { label: 'Admin', value: 'admin' },
  { label: 'Enterprise Admin', value: 'enterpriseAdmin' },
  // { label: 'QuoteToolAdmin', value: 'quoteToolAdmin' },
  { label: 'Manufacturer', value: 'manufacturer' },
  { label: 'Support Engineer', value: 'supportEngineer' },
  { label: 'CompanyGroupAdmin', value: 'companyGroupAdmin' },
  { label: 'CompanyGroupManager', value: 'companyGroupManager' },
];

let companyGroupAdminItems = [
  { label: 'User', value: 'user' },
  { label: 'Admin', value: 'admin' },
  { label: 'Enterprise Admin', value: 'enterpriseAdmin' },
  { label: 'Manufacturer', value: 'manufacturer' },
  // { label: 'Support Engineer', value: 'supportEngineer' },
  // { label: 'CompanyGroupManager', value: 'companyGroupManager' },
];

const engineeringGroupItems = [
  ...superAdminItems,
  { label: 'SuperAdmin', value: 'superAdmin' },
]

const ALLOWED_ROLES_ACCOUNT_UNLOCK = ['superAdmin', 'companyGroupAdmin'];

const UpdateUserModal = ({
  isOpen,
  onConfirm,
  onCancel,
  users,
  resetPasswordByOld,
  user,
  userRole,
  updateUser,
  changeFieldUpdateUser,
  securityPassed,
  hideSecurityModal,
  getUserPermissions,
  userResetPassword,
  permissionGroupsList,
  getUserAccountLock,
  getOobmDeviceEnabled,
  assignUsersOobm,
  getUserOobm,
  getCompanyGroupByUser,
  getUserCompanyGroup
}) => {
  const [newPassword, setNewPassword] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [repeatNewPassword, setRepeatNewPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [role, setRole] = useState(users.updateUser.role);
  const [modalStatus, setModalStatus] = useState(false);
  const [selectRole, setSelectRole] = useState(undefined);
  const [selectionTrigger, setSelectionTrigger] = useState('');
  const [selectedValue, setSelectedValue] = useState('');
  const [readOnlyTriggered, setReadOnlyTriggered] = useState(false);
  const [readOnlyValue, setReadOnlyValue] = useState(users.updateUser.readOnly);
  const [isReleaseNotesAdmin, setIsReleaseNoteAdmin] = useState(
    users.updateUser.isReleaseNotesAdmin,
  );
  const [tempRole, setTempRole] = useState(undefined);
  const [hasOobBox, sethasOobBox] = useState(false);
  const [accountLocked, setAccountLocked] = useState(false);
  const [resetModal, setResetModal] = useState(false);
  const [resetForm, setResetForm] = useState(null);
  // const [monitorSecurityModal, setMonitorSecurityModal] = useState(false);
  const [selectedUser] = useState(users?.updateUser ?? {})
  const [selectedUserPermissionGroup, setSelectedUserPermissionGroup] = useState(selectedUser?.permissionsGroup || '');
  const [selectedUserPermissions, setSelectedUserPermissionPermission] = useState([]);
  const [companyGroups, setCompanyGroups] = useState([]);
  const [selectedCompanyGroupObjects, setSelectedCompanyGroupObjects] = useState([]);
  const [companyGroupSearchTerm, setCompanyGroupSearchTerm] = useState('');
  const [selectUserCompanyGroup, setSelectedId] = useState('');
  const [roleChange, setRoleOnChange] = useState();

  const [addUserNoteModal, setAddUserNoteModal] = useState(false);
  const [userNoteText, setUserNoteText] = useState(selectedUser?.userNote?.noteText || '');
  const [userNoteLoading, setUserNoteLoading] = useState(false);

  const fetchCompanyGroups = async (companyId) => {
    if (!companyId) {
      setCompanyGroups([]);
      setSelectedCompanyGroupObjects([]);
      return;
    }
    const groups = await getCompanyGroupByUser(token, companyId, users.updateUser._id);
    const userCompanyGroups = await getUserCompanyGroup(token, users.updateUser._id);
    const selected = Array.isArray(userCompanyGroups)
      ? userCompanyGroups.filter((g) => g?._id)
      : userCompanyGroups?._id
        ? [userCompanyGroups]
        : [];

    setCompanyGroups(Array.isArray(groups) ? groups : []);
    setSelectedCompanyGroupObjects(selected);
    const selectedIds = selected.map((g) => g._id);
    setSelectedId(selectedIds);
    changeFieldUpdateUser('selectedGroups', selectedIds);
  };
  useEffect(() => {
    const company = users?.updateUser?.company;
    const companyId =
      typeof company === 'string'
        ? company
        : company?._id;

    if (companyId) {
      fetchCompanyGroups(companyId);
    } else {
      setCompanyGroups([]);
    }
  }, [users?.updateUser?.company]);
  const { data: isReachedMaxAttempts } = useUnifiedFetch(
    `users/${selectedUser?._id}/isReachedMaxAttempts`,
    true,
    true,
  );

  const [companyGroupAdminDropdown, setCompanyGroupAdminDropdown] = useState(companyGroupAdminItems)
  // fetch permissions by group name
  const { data: permissionsByGroupName } = useUnifiedFetch(
    `permissionGroups/permissionsByGroupName/${selectedUserPermissionGroup}`,
    true,
    true,
  );

  // set permissions by group name
  useEffect(() => {
    if (permissionsByGroupName) {
      // list all permission of selected user Group permissions + extra permission
      let extraPermissions = selectedUser.extraPermissions || {};
      let selectedUserPermissions = { ...permissionsByGroupName.permissions }
      Object.keys(extraPermissions).forEach(element => {
        selectedUserPermissions[element] = { ...selectedUserPermissions[element], ...extraPermissions[element] }
      });
      setSelectedUserPermissionPermission(selectedUserPermissions);
      let updatedPermissions = { ...basicPermissions, ...selectedUserPermissions }
      setToggleStates(updatedPermissions)
    }
  }, [permissionsByGroupName])

  // const allPermissionGroups = useSelector(state => state.AppState.permissionGroups);

  const token = localStorage.getItem('jwtToken');

  const myRole = useMemo(() => user.role, [user]);

  const { hasUserPermissionToChange } = useUpdateUserModal();
  const [permissionsListByGroup, setPermissionsListByGroup] = useState([])

  useEffect(() => {
    if (user.role === 'companyGroupAdmin' && user.manager) {
      setCompanyGroupAdminDropdown(prev => {
        const exists = prev.some(x => x.value === 'companyGroupAdmin');
        if (exists) return prev;
        return [...prev, { label: 'CompanyGroupAdmin', value: 'companyGroupAdmin' }];
      });
    }

    if(updateUser?.role === 'companyGroupAdmin') {
      setCompanyGroupAdminDropdown(prev => {
        const exists = prev.some(x => x.value === 'companyGroupAdmin');
        if (exists) return prev;
        return [...prev, { label: 'CompanyGroupAdmin', value: 'companyGroupAdmin' }];
      });
    }
  }, [user.role, user.manager]);

  const getData = async () => {
    let roleList = [];
    if (userRole === 'superAdmin') {
      roleList = user.permissionsGroup === 'Engineering' ? engineeringGroupItems : superAdminItems;
    } else if (userRole === 'companyGroupAdmin') {
      roleList = companyGroupAdminDropdown;
    } else {
      roleList = adminItems;
    }
    const currentRole = roleList.find(el => el.value === updateUser.role) || roleList[0];
    const { isAccountLocked, hasOobBox } = await getUserAccountLock(token, users.updateUser._id);
    setSelectRole(currentRole);
    setSelectedValue(currentRole.value);
    setTempRole(selectedValue);
    setAccountLocked(isAccountLocked);
    sethasOobBox(hasOobBox)
  };

  useEffect(() => {
    setRole(users.updateUser.role);
  }, [users.updateUser.role]);

  useEffect(() => {
    getData().catch(console.error);
  }, []);

  useEffect(() => {
    if (securityPassed) {
      submitResetCall('sudo');
    }
  }, [securityPassed]);

  const [basicPermissions, setBasicPermissions] = useState({
    warehouseQcRecAccess: selectedUser?.warehouseQcRecAccess ?? false,
    lockReminder: selectedUser?.lockReminder ?? false,
    deleteLock: selectedUser?.deleteLock ?? false,
    accountLocked: selectedUser?.accountLocked ?? false,
    isAccountApprover: selectedUser?.isAccountApprover ?? false, 
    epikEngineering: selectedUser?.epikEngineering ?? false,
    epikV2Access: selectedUser?.epikV2Access ?? false,
    manager: selectedUser?.manager || false,
    oobmnEdpointAssignment: selectedUser?.oobmnEdpointAssignment ?? false,  
  })
  
  useEffect(() => {
    const permissionsList = permissionGroupsList || {};// use only to list the permissions
    // get default permission based on group name
    const permissionsListByGroup = []
    Object.keys(permissionsList).map(perm => {
      if (permissionsList[perm]?.read || permissionsList[perm]?.write) {
        permissionsListByGroup.push(perm)
      }
    })
    // arrange permissions according to their category
    let newArray = []
    Object.keys(categorziedPermissions).map(key => {
      let permissionList = categorziedPermissions[key];
      let filteredValues = permissionList.filter(val => permissionsListByGroup.includes(val));

      // sort array not by permission label rather than permission name/id
      filteredValues.sort((a, b) => {
        const labelA = (allPermissionsListWithLabel[a]?.label || '').toLowerCase();
        const labelB = (allPermissionsListWithLabel[b]?.label || '').toLowerCase();
        if (labelA < labelB) return -1;
        if (labelA > labelB) return 1;
        return 0;
      });

      filteredValues.length && newArray.push({ [key]: filteredValues })
    })

    // sort array according to keys i.e edgeDevice, systemTools etc
    newArray.sort((a, b) => {
      const keyA = Object.keys(a)[0].toLowerCase();
      const keyB = Object.keys(b)[0].toLowerCase();
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    });

    setPermissionsListByGroup(newArray)
  }, []);

  const submitResetCall = async e => {
    const id = users.updateUser._id;
    hideSecurityModal();
    if (newPassword === repeatNewPassword) {
      await resetPasswordByOld(token, id, oldPassword, newPassword, e === 'sudo');
      setNewPassword('');
      setOldPassword('');
      setRepeatNewPassword('');
    } else {
      setErrorMessage('New password and its confirmation do not match. Please, re-enter!');
    }
  };
  const onSubmit = async e => {
    const { auto, email, password, loginFirst, confirmPassword } = resetForm;

    const body = {
      hasGeneratePassword: auto,
      userPassword: password,
      resetUserID: updateUser._id,
      hasSendAdminEmail: email,
      hasResetPasswordOnLogin: loginFirst,
    };

    const reset = await userResetPassword(token, body);
    if (reset.success) {
      setResetModal(false);
      setResetForm(null);
    }
  };
  const currentSelectedRole = role => {
    const roleList =
      userRole === 'superAdmin'
        ? (user.permissionsGroup === 'Engineering' ? engineeringGroupItems : superAdminItems)
        : userRole === 'companyGroupAdmin'
          ? companyGroupAdminDropdown
          : adminItems;
    return roleList.find(el => el.value === role) || roleList[0];
  };

  const changeFieldUpdate = () => {
    const currentRole = currentSelectedRole(!!tempRole ? tempRole : selectedValue);
    setModalStatus(false);
    setSelectionTrigger(true);
    setSelectRole({ ...currentRole });
    setSelectedValue(currentRole.value);
    changeFieldUpdateUser('role', tempRole ? tempRole : selectedValue);
    if (currentRole.value !== 'superAdmin') {
      setToggleStates(prevState => ({
        ...prevState,
        epikEngineering: false,
      }));
      changeFieldUpdateUser('epikEngineering', false);
    }
  };

  const onReadOnlyToggleChange = async () => {
    await changeFieldUpdateUser('readOnly', !updateUser.readOnly);
    setReadOnlyValue(
      selectedValue === 'superAdmin' ||
        selectedValue === 'companyGroupAdmin' ||
        selectedValue === 'admin' ||
        selectedValue === 'enterpriseAdmin'
        ? !readOnlyValue
        : false,
    );
  };

  const checkSecurityCode = () => {
    if (readOnlyTriggered) {
      onReadOnlyToggleChange();
    } else {
      changeFieldUpdate();
    }
    setSelectionTrigger('confirm');
    setModalStatus(false);
  };
  const isUserAllowedToUnlockAccount = () => {
    return ALLOWED_ROLES_ACCOUNT_UNLOCK.includes(userRole);
  };

  const onWrongCode = () => {
    const currentRole = currentSelectedRole(userRole);
    // setSelectRole(currentRole);
    setTempRole(userRole);
    setSelectedValue(currentRole.value);
  };

  const roleSelection = async value => {
    const currentRole = currentSelectedRole(value);
    setRoleOnChange(currentRole)
    changeFieldUpdateUser('role', value);
    setSelectionTrigger('');

    setReadOnlyTriggered(false);
    setSelectRole(currentRole);
    setTempRole(value);
    setSelectedValue(value);
    if (value !== 'superAdmin') {
      setToggleStates(prevState => ({
        ...prevState,
        epikEngineering: false,
      }));
      await changeFieldUpdateUser('epikEngineering', false);
    }

    // commenting this code as we are using Permission Groups now

    // if (userRole === 'superAdmin' && role === 'superAdmin') {
    //   const KEY_IN_REDUX_STATE = 'dataCenterMonitor';
    //   const KEY_IN_REDUX_STATE_DM = 'deviceMonitor';
    //   setDataCenterMonitor(false);
    //   setDeviceMonitor(false);
    //   setNumberCarrierChangeAccess(false);
    //   await changeFieldUpdateUser(KEY_IN_REDUX_STATE, false);
    //   await changeFieldUpdateUser(KEY_IN_REDUX_STATE_DM, false);
    //   await changeFieldUpdateUser('numberCarrierChangeAccess', false);
    // }
  };


  const onUpdateConfirm = async () => {
    const currentSelectedIds = (selectedCompanyGroupObjects || [])
      .map(g => g?._id)
      .filter(Boolean);
    const removedGroups = selectUserCompanyGroup.filter(id => !currentSelectedIds.includes(id));
    const addedGroups = currentSelectedIds.filter(id => !selectUserCompanyGroup.includes(id));
    await changeFieldUpdateUser('selectedGroups', currentSelectedIds);
    await changeFieldUpdateUser('removedGroups', removedGroups);
    await changeFieldUpdateUser('addedGroups', addedGroups);
  
    await changeFieldUpdateUser('isReleaseNotesAdmin', isReleaseNotesAdmin);
    await changeFieldUpdateUser('permissionsGroup', selectedUserPermissionGroup);
    onConfirm();
  };

  const onResetPassword = async () => {
    setResetModal(true);
  };
  const hiddenCarrier = () => {
    if (
      (userRole === 'superAdmin' || userRole === 'companyGroupAdmin') &&
      (role === 'superAdmin' || role === 'companyGroupAdmin')
    ) {
      return false;
    }
    return true;
  };
  const formValues = values => {
    setResetForm(values);
  };

  const [activeButton, setActiveButton] = useState('userInfo');
  const [isAccessControlOpen, setIsAccessControlOpen] = useState(false);

  const handleButtonClick = (button) => {
    setActiveButton(button);
    if (button === 'accessControl') {
      setIsAccessControlOpen(true);
    }
    if (button === 'userInfo') {
      setIsAccessControlOpen(false);
      setActiveButton('userInfo');
    }
  };

  const [toggleStates, setToggleStates] = useState({
    warehouseQcRecAccess: selectedUser?.warehouseQcRecAccess ?? false,
    lockReminder: selectedUser?.lockReminder ?? false,
    deleteLock: selectedUser?.deleteLock ?? false,
    accountLocked: selectedUser?.accountLocked ?? false,
    isAccountApprover: selectedUser?.isAccountApprover ?? false, 
    epikEngineering: selectedUser?.epikEngineering ?? false,
    epikV2Access: selectedUser?.epikV2Access ?? false,
    manager: selectedUser?.manager || false,
    oobmnEdpointAssignment: selectedUser?.oobmnEdpointAssignment ?? false, 
    ...selectedUserPermissions
  });
const [getEnabledOobmDevices, setGetEnabledOobmDevices] = useState();
const [endpointModal, setEndpointModal] = useState(false);
const [selectedDevices, setSelectedDevices] = useState([]);
const [deviceDetails, setDeviceDetails] = useState({});
const [detailsModalOpen, setDetailsModalOpen] = useState(false);
const [activeDevice, setActiveDevice] = useState(null);
const [detailsForm, setDetailsForm] = useState({ customName: '', categories: [] });
const [savedEndpointIds, setSavedEndpointIds] = useState([]);
const [deviceRows, setDeviceRows] = useState([]);
const [selectedRowIds, setSelectedRowIds] = useState([]);
const [openedFromCheckboxDid, setOpenedFromCheckboxDid] = useState(null);

  useEffect(() => {
    setToggleStates(pre => ({
      ...pre,
      ...selectedUserPermissions
    }))
  }, [selectedUserPermissions])

  useEffect(() => {
    const fetchMaintenanceNotes = async () => {
      try {
        const data = await getOobmDeviceEnabled(token,users.updateUser._id);
        setGetEnabledOobmDevices(data)
      } catch (error) {
        console.error("Error fetching maintenance notes:", error);
      }
    };
    fetchMaintenanceNotes();
  }, [token]);

  const onEndpointSelection = async () => {
    try {
      const data = await getUserOobm(token, users.updateUser._id);
      const ids = Array.isArray(data) ? data.map(x => String(x?._id)).filter(Boolean) : [];
      setSavedEndpointIds(ids);
    } catch { }
    setEndpointModal(true);
  };
  const getDeviceLabel = (d) =>
    d?.displayName ?? d?.deviceName ?? d?.name ?? d?.serialNumber ?? 'Device';

  const openDeviceDetails = (device) => {
    const did = getDeviceId(device);
    const existing = deviceDetails[did] || {
      customName: device.displayName || '',
      categories: [],
      endpoints: []
    };
    setActiveDevice({ ...device, __did: did, __label: getDeviceLabel(device) });
    setDetailsForm({
      endpointName: device.displayName || device.deviceName || device.name || '',
      customName: existing.customName || (device.displayName || device.deviceName || device.name || ''),
      categories: existing.categories || [],
    });
    const allRows = listAllEndpointsForDevice(device);
    setDeviceRows(allRows);
    const savedIdsForDevice = new Set((existing.endpoints || []).map(r => String(r._id)));
    setSelectedRowIds(
      allRows.filter(r => savedIdsForDevice.has(String(r._id))).map(r => r._id)
    );
    setDetailsModalOpen(true);
  };
  useEffect(() => {
    if (!users?.updateUser?._id) return;
    (async () => {
      try {
        const data = await getUserOobm(token, users.updateUser._id);
        const ids = Array.isArray(data) ? data.map(x => String(x?._id)).filter(Boolean) : [];
        setSavedEndpointIds(ids);
      } catch (e) {
        setSavedEndpointIds([]);
      }
    })();
  }, [token, users?.updateUser?._id]);

  useEffect(() => {
    if (!Array.isArray(getEnabledOobmDevices) || getEnabledOobmDevices.length === 0) return;
    const saved = new Set(savedEndpointIds);
    const nextSelectedDevices = [];
    const nextDeviceDetails = {};
    for (const device of getEnabledOobmDevices) {
      const did = getDeviceId(device);
      const rows = listAllEndpointsForDevice(device);
      const chosen = rows.filter(r => saved.has(String(r._id)));
      if (chosen.length) {
        nextSelectedDevices.push(did);
        nextDeviceDetails[did] = {
          customName: device.displayName || device.deviceName || device.name || '',
          categories: [],
          endpoints: chosen,
        };
      }
    }
    setSelectedDevices(nextSelectedDevices);
    setDeviceDetails(nextDeviceDetails);
  }, [getEnabledOobmDevices, savedEndpointIds]);


  const toggleRow = (id) =>
    setSelectedRowIds(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );

  const allChecked = deviceRows.length > 0 && selectedRowIds.length === deviceRows.length;

  const toggleAll = () =>
    setSelectedRowIds(prev =>
      prev.length === deviceRows.length ? [] : deviceRows.map(r => r._id)
    );

  const saveDeviceDetails = () => {
    if (!activeDevice) return;

    const did = activeDevice.__did ?? getDeviceId(activeDevice);
    const chosenRows = deviceRows.filter(r => selectedRowIds.includes(r._id));
    setDeviceDetails(prev => {
      if (chosenRows.length === 0) {
        const { [did]: _discard, ...rest } = prev;
        return rest;
      }
      return {
        ...prev,
        [did]: {
          customName: detailsForm.customName || '',
          categories: detailsForm.categories || [],
          endpoints: chosenRows,
        },
      };
    });
    setSelectedDevices(prev => {
      return chosenRows.length
        ? (prev.includes(did) ? prev : [...prev, did])
        : prev.filter(x => x !== did);
    });
    setDetailsModalOpen(false);
  };

  const onConfirmEndpoints = async () => {
    const ids = Array.isArray(selectedDevices) ? selectedDevices : Array.from(selectedDevices);
    const endpointIds = ids
      .flatMap(did => (deviceDetails[did]?.endpoints || []).map(ep => ep?._id))
      .filter(Boolean)
      .map(String);
    const newSet = new Set(endpointIds);
    const oldSet = new Set((savedEndpointIds || []).map(String));
    const toAdd = [...newSet].filter(x => !oldSet.has(x));
    const toRemove = [...oldSet].filter(x => !newSet.has(x));
    const payload = [{
      user: users.updateUser._id,
      oobs: toAdd,
      removeOobs: toRemove,
    }];
    const ok = await assignUsersOobm(token, payload);
    if (ok) toast.success('Saved endpoint selection(s) successfully');
    setEndpointModal(false);
  };


  const handleToggleChange = useCallback(async (key, value) => {
    const newValue = !value;
    // Added check to validate if OOBM permission is enabled then TTY permission can be enabled
    // if (key === 'outBandManagement' && !newValue) {
    //   setToggleStates(prevState => ({
    //     ...prevState,
    //     ttyOptionsAccess: false,
    //   }));
    //   await changeFieldUpdateUser('ttyOptionsAccess', false);
    // }

    setToggleStates(prevState => ({
      ...prevState,
      [key]: newValue,
    }));
    await changeFieldUpdateUser(key, newValue);
  }, []);


  const handleAccessControlToggleChange = (async (key, value = false, permissionName) => {

    const newValue = !value;

    if (key === 'ttyOptionsAccess' && newValue) {
      if (!(toggleStates['outBandManagement']?.[permissionName])) {
        toast.warn(`To enable this permission OOBM '${permissionName}' Permission is required`)
        return
      }
    }
    // Added check to validate if OOBM permission is enabled then TTY permission can be enabled
    if (key === 'outBandManagement' && !newValue) {
      setToggleStates(prevState => ({
        ...prevState,
        ttyOptionsAccess: false,
      }));
      await changeFieldUpdateUser('ttyOptionsAccess', false);
    }

    let updatedPermission = permissionName ? { ...permissionName[key], [permissionName]: newValue } : newValue

    if (permissionName) { //update permission object in state
      let previousPermission = { ...toggleStates[key] };
      updatedPermission = { ...previousPermission, ...updatedPermission }
    }

    let extraPermissions = { ...users.updateUser.extraPermissions };

    if (!updatedPermission[permissionName]) {
      delete extraPermissions[key]
    }
    else {
      extraPermissions = { ...extraPermissions, [key]: updatedPermission };
    }

    setToggleStates(prevState => ({
      ...prevState,
      [key]: updatedPermission,
    }));
    await changeFieldUpdateUser('extraPermissions', extraPermissions);
  });


  const permissionComponents = {
    ...toggleStates,
    handleToggleChange,
  };

  const [savedUser, setSavedUser] = useState(users.updateUser)
  const handleDetailsCancel = () => {
    setDetailsModalOpen(false);

    const did = openedFromCheckboxDid || activeDevice?.__did;
    if (!did) return;

    const hadSaved = Array.isArray(deviceDetails[did]?.endpoints) && deviceDetails[did].endpoints.length > 0;
    const pickedAnyNow = selectedRowIds.length > 0;

    if (!hadSaved && !pickedAnyNow) {
      setSelectedDevices(prev => prev.filter(x => x !== did));
      setDeviceDetails(prev => {
        const { [did]: _drop, ...rest } = prev;
        return rest;
      });
    }
    setOpenedFromCheckboxDid(null);
  };
  
  useEffect(() => {
    if (isReachedMaxAttempts) {
      setToggleStates(prevState => ({ ...prevState, accountLocked: true }));
    }
  }, [isReachedMaxAttempts]);

  const isAllowedToUpdatePermissions = () => {
    // if (user.epikEngineering) { return true }; // have full access

    // manager can edit person of same group 
    if (user.manager && (user.permissionsGroup === selectedUser.permissionsGroup || user.epikEngineering)) {
      return true
    }
    // manager can edit person of same group + customer and partner
    const allowedGroups = ['Customer', 'Partner'];
    if (user.manager && allowedGroups.includes(selectedUser.permissionsGroup)) {
      return true 
    }
    return false; // not a manager
  }

  const isEditable = (permissionName, permissionValue, permissionAccess) => {
    const permissionInGroup = permissionsByGroupName.permissions?.[permissionName];

    if (permissionInGroup?.[permissionAccess] && permissionValue) {
      return true // disable permission if it is set in group and user has it
    } else {
      return false
    }
  }
  const getDeviceId = (d) =>
    d?._id ?? d?.id ?? d?.deviceId ?? d?.serialNumber ?? d?.deviceName ?? String(Math.random());
  const listAllEndpointsForDevice = (device) => {
    if (!device?.numbers || !Array.isArray(device.numbers)) return [];
    return device.numbers.map(n => {
      const up = n.usbPort || {};
      const cat = up.usbCategory || {};
      return {
        _id: n._id,
        number: n.number || '-',
        usbTitle: up.customTitle || '-',
        title: up.title || '-',
        categoryTitle: cat.title || '-',
        allowTTY: Boolean(up.allowTTY),
        disconnected: Boolean(up.disconnected),
      };
    });
  };
  
  const limitedGroups = ["Customer", "OOBM Only"];

  const isCompanyGroupAdmin = userRole === "companyGroupAdmin";
  const isChangingRoleToAdmin = selectedValue === "admin";  
  
  const groupOptions =
    isCompanyGroupAdmin && isChangingRoleToAdmin
      ? limitedGroups
      : RESTRICTED_PERMISSION_GROUPS;
  const selectedIds = selectedCompanyGroupObjects.map((g) => g._id).filter(Boolean);
  const availableCompanyGroups = companyGroups.filter((g) => g._id && !selectedIds.includes(g._id));
  return (
    <Modal isOpen={isOpen} className="custom-modal-style">
      <div style={{ borderBottom: "1px solid #e0e0e0" }}>
        <div style={{ padding: "20px 20px 5px 20px" }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', }}>
            <div style={{ fontSize: 18, fontWeight: 'bold', }}>Update User</div>
            {!selectedUser?.userNote?.noteText && user.permissionsGroup === 'Engineering' &&
              <Button color="primary" onClick={() => setAddUserNoteModal(true)} style={{ marginLeft: '10px' }}> Add Note</Button>
            }
          </div>
          {selectedUser?.userNote?.noteText && user.permissionsGroup === 'Engineering' &&
            <div className="user-note-container">
              <p style={{ margin: 0 }}>
                <b>Note:</b> {selectedUser?.userNote?.noteText}
                <br />
                <span style={{ fontSize: 12, color: 'gray' }}>Added on  <b>
                  {utils.getDateTimeFormat(selectedUser?.userNote?.createdAt, 'both')}</b> By <b>{selectedUser?.userNote?.createdBy}</b></span>
                <br />
                {selectedUser?.userNote?.updatedAt &&
                  <span style={{ fontSize: 12, color: 'gray' }}>Last updated on  <b>{utils.getDateTimeFormat(selectedUser?.userNote?.updatedAt, 'both')}</b> By <b>{selectedUser?.userNote?.updatedBy}</b></span>}
              </p>
              <Flex gap={10}>
                <img
                  onClick={() => {
                    setAddUserNoteModal(true)
                  }}
                  className="actions-icon"
                  src={edit}
                  alt="edit"
                />
                <Popconfirm
                  title="Are you sure you want to delete this note?"
                  description="This action cannot be undone."
                  onConfirm={() => {
                    changeFieldUpdateUser('userNoteText', null)
                    setUserNoteText('')
                    onUpdateConfirm()
                  }}
                >
                  <img
                    className="actions-icon"
                    src={del}
                    alt="delete"
                  />
                </Popconfirm>
              </Flex>
            </div>
          }
        </div>
      </div>
      <div className="button-container">
        <button
          className={`custom-btn user-info ${activeButton === 'userInfo' ? 'active' : ''}`}
          onClick={() => handleButtonClick('userInfo')}
        >
          USER INFO
        </button>
        {(isAllowedToUpdatePermissions()) &&
          <button
            className={`custom-btn access-control ${activeButton === 'accessControl' ? 'active' : ''}`}
            // onClick={() => setAccessControl(true)}
            onClick={() => handleButtonClick('accessControl')}
          >
            ACCESS CONTROL
          </button>
        }
      </div>
      <ModalBody>
        {activeButton === 'userInfo' ? (
          <Container>
            <UpdateUserForm role={role} permission={hasUserPermissionToChange} />
            {(role === 'superAdmin' || role === 'companyGroupAdmin') &&
              (myRole === 'admin' ||
                myRole === 'companyGroupManager' ||
                myRole === 'enterpriseAdmin') ? null : (
              <>
                <div className="form-row" style={{ marginBottom: '20px', marginTop: '20px' }}>
                  <div className="col-6 col-md-6 mb-3" style={{ display: 'flex', alignItems: 'center', flex: '1 1 auto' }}>
                    <Label className="label-style" style={{ marginLeft: '15px', marginRight: '10px' }}>Password</Label>
                    <Button
                      disabled={role === 'superAdmin' && myRole === 'companyGroupAdmin'}
                      onClick={onResetPassword}
                      color="primary"
                      style={{
                        padding: '6px 10px', // Adjust padding for better responsiveness  
                        minWidth: 'auto',    // Minimum width to maintain usability  
                        maxWidth: 'auto',    // Minimum width to maintain usability  
                        flex: '1 1 auto'      // Allow button to grow and shrink  
                      }}
                    >
                      Reset
                    </Button>
                  </div>
                  <div className="col-12 col-md-6 mb-3" style={{ display: 'flex', alignItems: 'center', flex: '1 1 auto' }}>
                    <Label for="roleSelect" className="label-style" style={{ marginLeft: '15px', marginRight: '10px' }}>
                      Role
                    </Label>
                    <Input
                      type="select"
                      id="roleSelect"
                      style={{ maxWidth: '78%' }}
                      value={role} // Make sure to control the value
                      onChange={({ target: { value } }) => roleSelection(value)} // Handle selection change
                    >
                      <option disabled value="">
                        Select a type
                      </option>
                      {userRole === 'superAdmin' &&
                        (user.permissionsGroup === 'Engineering' ? engineeringGroupItems : superAdminItems).map(item => (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      {userRole === 'companyGroupAdmin' &&
                          companyGroupAdminDropdown.map(item => (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                          ))}
                        {(userRole === 'admin' || userRole === 'user') ?
                          adminCustomerItems.map(item => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          )) :
                          userRole !== 'superAdmin' && userRole !== 'companyGroupAdmin' &&
                          adminItems.map(item => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))
                        }
                    </Input>
                  </div>
                    {(isAllowedToUpdatePermissions()) && (
                    <div className="col-12 col-md-6 mb-3" style={{ paddingLeft: '30px',display: 'flex', flexDirection : 'column', flex: '1 1 auto' }}>
                        <Row>
                          <Label for="roleSelect" className="label-style" >
                          Permission Groups
                          </Label>
                        </Row>
                        <Row>
                          <Input
                            type="select"
                            id="roleSelect"
                            style={{ maxWidth: '78%' }}
                            value={selectedUserPermissionGroup || ''}
                            onChange={({ target: { value } }) => setSelectedUserPermissionGroup(value)} 
                          >
                            <option disabled value="">
                              Select a type
                            </option>
                            {groupOptions.map((groupKey) => (
                              <option key={groupKey} value={groupKey}>
                                {groupKey}
                              </option>
                            ))}
                          </Input>
                        </Row>
                    </div>
                    )}
                    {(role === 'superAdmin' ||
                      role === 'companyGroupAdmin' ||
                      role === 'companyGroupManager') && (
                        <div className="col-12 col-md-6 mb-3">
                          <Label className="label-style">Company Group</Label>
                          <div className="email-list company-group-chips">
                            {selectedCompanyGroupObjects?.length > 0 && (
                              <div className="email-list">
                                {selectedCompanyGroupObjects.map((g) => (
                                  <div
                                    className={`multi-input-item${g.invalid ? ' invalid-company-group' : ''}`}
                                    key={g._id || g.name}
                                    title={
                                      g.invalid
                                        ? 'Please remove this group, as the management company does not include your company'
                                        : undefined
                                    }
                                  >
                                    <span className="item">{g?.name}</span>
                                    <span
                                      role="button"
                                      tabIndex={0}
                                      onClick={() => {
                                        const next = selectedCompanyGroupObjects.filter((x) => x?._id !== g?._id);
                                        setSelectedCompanyGroupObjects(next);
                                        changeFieldUpdateUser('selectedGroups', next.map((x) => x._id));
                                      }}
                                    >
                                      ×
                                    </span>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                          <OptionalDropdownSelect
                            key={`company-groups-${users?.updateUser?._id || ''}-${selectedIds.join(',')}`}
                            searchTerm={companyGroupSearchTerm}
                            nameTag="name"
                            // MultiSelect
                            className="testing-filter"
                            filterTag="name"
                            placeholder={
                              !availableCompanyGroups.length && companyGroups.length
                                ? 'No more selection'
                                : companyGroups.length
                                  ? 'Select Company Group'
                                  : 'No Company Group Found'
                            }
                            dropdownList={availableCompanyGroups}
                            onChange={(ev) => {
                              const suggestion = ev?.suggestion;
                              if (!suggestion?._id) return;
                              setCompanyGroupSearchTerm('');
                              setSelectedCompanyGroupObjects((prev) => {
                                if (prev.some((x) => x._id === suggestion._id)) {
                                  toast.error('Already added in the list');
                                  return prev;
                                }
                                const next = [...prev, suggestion];
                                changeFieldUpdateUser('selectedGroups', next.map((x) => x._id));
                                return next;
                              });
                            }}
                          />
                        </div>
                      )}
                </div>
                <div style={{ marginLeft: '15px' }}>
                  <Row style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {/* Status Toggle */}
                    <Col xs={12} sm={6} md={3} style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                      <Label for="enabled" className="label-style" style={{ marginRight: '1rem', flex: '1' }}>
                        Status:
                      </Label>
                      <label className="custom-togglee" style={{ marginLeft: 'auto' }}>
                        <input
                          type="checkbox"
                          checked={updateUser.enabled}
                          onChange={(e) => changeFieldUpdateUser('enabled', e.target.checked)}
                        />
                        <span className="slider"></span>
                      </label>
                    </Col>
                    {/* Read-only Toggle */}
                    {/* There is a read only toggle that we need to hide because we don't need it anymore since we have granular permissions. But I was told that we can't remove it completely because there is some backend logic tied to that switch so the thought was let's just hide it from the UI */}
                    {selectedUser?.readOnly &&<Col xs={12} sm={6} md={3} style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                      <Label for="readOnly" className="label-style" style={{ marginRight: '2rem', flex: '1' }}>
                        Read-only:
                      </Label>
                      <label className="custom-togglee" style={{ marginLeft: '0.1rem' }}>
                        <input
                          type="checkbox"
                          checked={readOnlyValue}
                          onChange={onReadOnlyToggleChange}
                        />
                        <span className="slider"></span>
                      </label>
                    </Col>}
                    {/* Release Notes Admin Toggle */}
                    {(userRole === 'superAdmin') &&
                      <Col xs={12} sm={6} md={3} style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                      <Label for="release" className="label-style" style={{ marginRight: '2rem', flex: '1' }}>
                        Release Notes Admin:
                      </Label>
                      <label className="custom-togglee" style={{ marginLeft: 'auto' }}>
                        <input
                          type="checkbox"
                          checked={isReleaseNotesAdmin}
                          onChange={() => {
                            setIsReleaseNoteAdmin(!isReleaseNotesAdmin);
                          }}
                        />
                        <span className="slider"></span>
                      </label>
                    </Col>
                    }
                  </Row>
                </div>
              </>
            )}
            <div style={{ margin: '1vh 1vw', marginLeft: '10px' }}>
              <h1 style={{ marginBottom: '4vh' }}>Advanced Permissions</h1>
              <Row>
                {userPermissions
                  .filter((perm) => !perm.condition || eval(perm.condition))
                  .map((perm) => (
                    <Col
                      key={perm.id}
                      xs={12}
                      sm={6}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: '1rem',
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <Label for={perm.id} className="label-style" style={{ marginRight: 0 }}>
                          {perm.label}
                        </Label>
                        {perm.id === 'oobmnEdpointAssignment' && permissionComponents[perm.checked] && (
                          <Button
                            color="primary"
                            onClick={onEndpointSelection}
                            style={{ padding: '6px 14px', borderRadius: 10, fontWeight: 600 }}
                          >
                            Endpoint Selection
                          </Button>
                        )}
                      </div>
                      <label className="custom-toggle" style={{ flexShrink: 0 }}>
                        <input
                          type="checkbox"
                          checked={permissionComponents[perm.checked]}
                          onChange={() =>
                            permissionComponents[perm.onChange](perm.checked, permissionComponents[perm.checked])
                          }
                          disabled={perm.disabledCondition ? eval(perm.disabledCondition) : false}
                        />
                        <span className="slider"></span>
                      </label>
                    </Col>
                  ))}
              </Row>
              {/* <Row>
                {userPermissions
                  .filter((perm) => !perm.condition || eval(perm.condition)) // Include items that do not have a condition  
                  .map((perm, index) => (
                    <Col key={perm.id} xs={12} sm={6} style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                      <Label for={perm.id} style={{ flex: 1, marginRight: '1rem' }} className="label-style">
                        {perm.label}
                      </Label>
                      <label className="custom-toggle" style={{ flexShrink: 0 }}>
                        <input
                          type="checkbox"
                          checked={permissionComponents[perm.checked]}
                          onChange={() =>
                            permissionComponents[perm.onChange](perm.checked, permissionComponents[perm.checked])
                          }
                          disabled={perm.disabledCondition ? eval(perm.disabledCondition) : false}
                        />
                        <span className="slider"></span>
                      </label>
                    </Col>
                  ))}
              </Row> */}
            </div>
          </Container> 
        ) : (

            <Container>
              {
                selectedUser?.permissionsGroup && <Row>
                <Col md={4} sm={3} xs={6} style={{}}></Col>
                <Col md={2} sm={3} xs={6} style={{}}>
                  <Row style={{ padding: 0 }}>
                    <Col style={{ padding: 0 }}>
                        <Label className="" style={{ fontWeight: 'bold' }}> Read </Label>
                    </Col>
                      <Col style={{ padding: 0 }}> <Label className="-style" style={{ fontWeight: 'bold' }}>Write  </Label>
                    </Col>
                  </Row>
                </Col>
                <Col md={4} sm={3} xs={6} style={{}}></Col>
                <Col md={2} sm={3} xs={6} style={{}}>
                  <Row>
                    <Col style={{ padding: 0 }}>
                        <Label className="" style={{ fontWeight: 'bold' }}> Read  </Label>
                    </Col>
                    <Col style={{ padding: 0 }}>
                        <Label className="" style={{ fontWeight: 'bold' }}>Write  </Label>
                    </Col>
                  </Row>
                </Col>
              </Row>
              }

              <Row>
                {selectedUser?.permissionsGroup ? (permissionsListByGroup || [])
                  .map((category, index) => {
                    const categoryName = Object.keys(category)[0]
                    let catPermissions = category[categoryName]
                    // Break categoryName based on each capital letter and join with spaces
                    const formattedCategoryName = categoryName.replace(/([A-Z])/g, ' $1').trim();

                    return (
                      <React.Fragment key={index}>
                        <Col md={12} sm={12} xs={12}
                          className={"permission-category-label"} >{formattedCategoryName}</Col>
                        <Col md={12} sm={12} xs={12}>
                          <Row>
                            {
                              catPermissions.map(perm => {
                                const permission = allPermissionsListWithLabel[perm];
                                const id = permission?.id;
                                return (
                                  <>
                                    <Col md={4} sm={3} xs={5} style={{ paddingTop: 10, paddingBottom: 10, borderBottom: '0px solid ', }}>
                                      <Label for={id} className="label-style">
                                        {permission?.label}
                                      </Label>
                                    </Col>
                                    <Col md={2} sm={3} xs={5} style={{ paddingTop: 10, paddingBottom: 10, borderBottom: '0px solid ', }}>
                                      <Row>
                                        <Col span={6}>
                                          <ConfigProvider
                                            theme={{
                                              token: {
                                                /* here is your global tokens */
                                                colorBorder: isEditable(id, permissionComponents[id]?.read, 'read') ? 'lightgray' : '#1677ff',
                                              },
                                            }}
                                          >
                                            <Checkbox
                                              disabled={isEditable(id, permissionComponents[id]?.read, 'read')}
                                              checked={permissionComponents[id]?.read}
                                              onChange={() => handleAccessControlToggleChange(id, permissionComponents[id]?.read, 'read', perm)}
                                  // style={{ borderBottom: savedUser[id]?.read != permissionComponents[id]?.read ? '3px solid red' : '', }}
                                            />
                                          </ConfigProvider>
                                        </Col>
                                        <Col span={6}>
                                          <ConfigProvider
                                            theme={{
                                              token: {
                                                /* here is your global tokens */
                                                colorBorder: isEditable(id, permissionComponents[id]?.write, 'write') ? 'lightgray' : '#1677ff',
                                              },
                                            }}
                                          >
                                            <Checkbox
                                              disabled={isEditable(id, permissionComponents[id]?.write, 'write')}
                                              checked={permissionComponents[id]?.write}
                                              onChange={() => { handleAccessControlToggleChange(id, permissionComponents[id]?.write, 'write', perm) }}
                                  // style={{ borderBottom: savedUser[id]?.write != permissionComponents[id]?.write ? '3px solid red' : '', }}
                                            />
                                          </ConfigProvider>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </>
                                )
                              })
                            }
                          </Row>
                        </Col>
                      </React.Fragment>
                    )
                  })
                  :
                  <p className='no-permission-label'>No Permission group is assigned yet</p>}
            </Row>
          </Container>)}
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel} >
          Cancel
        </Button>{' '}
        <Button color="primary" onClick={onUpdateConfirm}>
          Update User
        </Button>
      </ModalFooter>
      <AddSecurityCodeModal
        isOpen={modalStatus}
        onCancel={() => {
          setSelectionTrigger('cancel');
          setModalStatus(!modalStatus);
          onWrongCode();
        }}
        onConfirm={checkSecurityCode}
        onWrongCode={onWrongCode}
        superCode
        featureName="superCode"
      />
      <CustomModal
        isOpen={resetModal}
        onCancel={() => setResetModal(false)}
        header="Reset Password"
        onConfirm={onSubmit}
        confirmDisabled={
          !resetForm?.auto &&
          (!utils.validatePassword(resetForm?.password, updateUser.email) ||
            resetForm?.password !== resetForm?.confirmPassword)
        }
      >
        <ResetPassword formValues={formValues} />
      </CustomModal>
      {/* --- ADD: Modal #1 — Device list + multi-select --- */}
      <Modal
        isOpen={endpointModal}
        toggle={() => setEndpointModal(false)}
        size="xl"
        centered
        scrollable
        backdrop="static"
        className="endpoint-modal"
      >
        <ModalHeader toggle={() => setEndpointModal(false)}>
          Select EPIK Devices
        </ModalHeader>
        <ModalBody>
          <div
            className="table-responsive"
            style={{ maxHeight: '60vh', overflow: 'auto', border: '1px solid #eee', borderRadius: 8 }}
          >
            <div style={{ maxHeight: 420, overflow: 'auto', border: '1px solid #eee', borderRadius: 8 }}>
              <table className="table table-hover mb-0">
                <thead>
                  <tr>
                    <th style={{ width: 56 }}>Select</th>
                    <th>Device Name</th>
                    <th>Serial Number</th>
                    <th>Location</th>
                  </tr>
                </thead>
                <tbody>
                  {(getEnabledOobmDevices || []).map((device) => {
                    const did = getDeviceId(device);
                    const isSelected = Array.isArray(selectedDevices)
                      ? selectedDevices.includes(did)
                      : selectedDevices.has(did);
                    const deviceName =
                      device.displayName ?? device.deviceName ?? device.name ?? '—';
                    const locationName =
                      device.location?.locationName ?? device.locationName ?? '—';
                    const serial = device.serialNumber ?? '—';
                    return (
                      <tr
                        key={did}
                        onClick={() => openDeviceDetails(device)}
                        style={{ cursor: 'pointer' }}
                        title="Click row to edit details"
                      >
                        <td onClick={(e) => e.stopPropagation()}>
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={(e) => {
                              e.stopPropagation();
                              const hasNumbers = Array.isArray(device?.numbers) && device.numbers.length > 0;
                              if (!hasNumbers) {
                                e.preventDefault();
                                toast.warn('Device has no assigned number');
                                return;
                              }
                              const goingToBeChecked = !isSelected;
                              setSelectedDevices((prev) => {
                                if (Array.isArray(prev)) {
                                  return goingToBeChecked
                                    ? (prev.includes(did) ? prev : [...prev, did])
                                    : prev.filter((x) => x !== did);
                                }
                                const next = new Set(prev ?? []);
                                goingToBeChecked ? next.add(did) : next.delete(did);
                                return next;
                              });

                              setDeviceDetails((prev) => {
                                if (goingToBeChecked) {
                                  const existing = prev[did] || { customName: '', categories: [], endpoints: [] };
                                  const endpointsToKeep =
                                    Array.isArray(existing.endpoints) && existing.endpoints.length > 0
                                      ? existing.endpoints   
                                      : [];                  // first time -> no preselect
                                  return { ...prev, [did]: { ...existing, endpoints: endpointsToKeep } };
                                } else {
                                  const { [did]: _removed, ...rest } = prev;
                                  return rest;
                                }
                              });
                              if (goingToBeChecked) {
                                setOpenedFromCheckboxDid(did);
                                setTimeout(() => openDeviceDetails(device), 0);
                              } else {
                                if (openedFromCheckboxDid === did) setOpenedFromCheckboxDid(null);
                              }
                            }}
                          />
                        </td>
                        <td>
                          <Button
                            type="button"
                            onClick={(e) => { e.stopPropagation(); openDeviceDetails(device); }}
                            style={{ all: 'unset', cursor: 'pointer', color: '#0d6efd', textDecoration: 'underline' }}
                          >
                            {deviceName}
                          </Button>
                        </td>
                        <td>{serial}</td>
                        <td>{locationName}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="d-flex w-100">
          <Button
            className="ms-auto"
            color="secondary"
            onClick={() => setEndpointModal(false)}
          >
            Close
          </Button>

          <Button
            className="ms-auto"
            color="primary"
            onClick={onConfirmEndpoints}>
            Save
          </Button>

        </ModalFooter>
      </Modal>
      {/* Modal #2  — Device Details */}
      <Modal
        isOpen={detailsModalOpen}
        size="lg"
        centered
        scrollable
        zIndex={2000}
        backdropClassName="nested-backdrop"
        className="details-modal nested-modal"

      >
        <ModalHeader >
          {activeDevice ? `Device Details: ${activeDevice.displayName} ${activeDevice.serialNumber}` : '-'}
        </ModalHeader>
        <ModalBody>
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0" style={{ borderCollapse: 'separate', borderSpacing: 0 }}>
              <thead>
                <tr>
                  <th style={{ width: 48 }}>
                    <input type="checkbox" checked={allChecked} onChange={toggleAll} />
                  </th>
                  <th>BTN</th>
                  <th>Category</th>
                  <th>Endpoint</th>
                  <th>Title</th>
                  <th>State</th>
                  <th>TTY</th>
                </tr>
              </thead>
              <tbody>
                {deviceRows.map(row => {
                  const checked = selectedRowIds.includes(row._id);
                  return (
                    <tr
                      key={row._id}
                      onClick={() => toggleRow(row._id)}
                      style={{ cursor: 'pointer' }}
                      title="Click to select"
                    >
                      <td onClick={(e) => e.stopPropagation()}>
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={() => toggleRow(row._id)}
                        />
                      </td>
                      <td style={{ whiteSpace: 'nowrap' }}>{row.number}</td>
                      <td>{row.categoryTitle ? row.categoryTitle : '-'}</td>
                      <td>{row.usbTitle ? row.usbTitle : '-'}</td>
                      <td>{row.title ? row.title : '-'}</td>
                      <td>{row.disconnected ? 'Disconnected' : 'Connected'}</td>
                      <td>{row.allowTTY ? 'Yes' : 'No'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button outline color="secondary" onClick={() => {
            setDetailsModalOpen(false);
            handleDetailsCancel();
          }}>
            Cancel
          </Button>
          <Button color="primary" onClick={saveDeviceDetails}>
            Select
          </Button>
        </ModalFooter>
      </Modal>

      {
        addUserNoteModal && (
          // Modal to add note in user account
          <Modal isOpen={isOpen} style={{ width: '50%', }}>
            <div className="add-oob-category-container">
              <label className='modal-clr-heading'>Add Note</label>
              <div className='management-modal-content-section mt-2'>
                <Input
                  placeholder="Add Note"
                  required
                  type="textarea"
                  name="userNoteText"
                  rows={8}
                  value={userNoteText}
                  onChange={(e) => {
                    changeFieldUpdateUser('userNoteText', e.target.value);
                    setUserNoteText(e.target.value);
                  }}
                />
                <div className='management-modal-btn-section mt-3'>
                  <Button color="primary" disabled={userNoteLoading} onClick={onUpdateConfirm} className='ml-2 mr-2'>
                    {userNoteLoading ? <SpinnerCircles /> : 'Save'}
                  </Button>
                  <Button outline onClick={() => setAddUserNoteModal(false)}> Cancel </Button>
                </div>
              </div>
            </div>
          </Modal>
        )
      }
    </Modal>
  );
};

const mapStateToProps = state => ({
  users: state.UIState.users,
  user: state.AppState.user,
  userRole: state.AppState.user.role,
  updateUser: state.UIState.users.updateUser,
  securityCode: state.UIState.users.addedUser.security,
  permissionGroupsList: state.AppState.permissionGroup,

});

const mapDispatchToProps = dispatch => ({
  resetPasswordByOld: (token, id, oldPass, newPass, godMode) =>
    dispatch(resetPasswordByOld(token, id, oldPass, newPass, godMode)),
  changeFieldUpdateUser: (name, value) => dispatch(changeFieldUpdateUser(name, value)),
  getUserPermissions: (token, userID) => dispatch(getUserPermissions(token, userID)),
  userResetPassword: (token, body) => dispatch(userResetPassword(token, body)),
  getUserAccountLock: (token, userID) => dispatch(getUserAccountLock(token, userID)),
  getOobmDeviceEnabled: (token,userId) => dispatch(getOobmDeviceEnabled(token,userId)),
  assignUsersOobm: (token,payload) => dispatch(assignUsersOobm(token,payload)),
  getUserOobm: (token,payload) => dispatch(getUserOobm(token,payload)),
  getCompanyGroupByUser: (token, companyId, userId) =>
    dispatch(getCompanyGroupByUser(token, companyId, userId)),
  getUserCompanyGroup: (token, userId) =>
    dispatch(getUserCompanyGroup(token, userId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateUserModal);

